import { render } from "./userPaymentData.vue?vue&type=template&id=2e9ad988&ts=true"
import script from "./userPaymentData.vue?vue&type=script&lang=ts"
export * from "./userPaymentData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__